class CaptureCartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.cartTable = this.closest("capture-cart-table");
		this.addEventListener("click", (event) => {
			event.preventDefault();
			event.target.value = 0;
			this.cartTable.updateCartItemQuantity(event, true);
		});
	}
}

customElements.define("capture-cart-remove-button", CaptureCartRemoveButton);

class CaptureCartMemoriesButton extends HTMLElement {
	constructor() {
		super();
		this.cartTable = document.querySelector("capture-cart-items");
		this.addEventListener("click", (event) => {
			event.preventDefault();
			var blockId = this.getAttribute("data-block-id");
			var itemKey = this.getAttribute("data-item-key");
			var itemType = this.getAttribute("data-type");
			if (blockId && itemKey) {
				var existingCartItems =
					document.getElementById(`CartItems-json`)?.textContent ??
					{};
				var parsedExistingCartItems = JSON.parse(existingCartItems);
				var cartItem = parsedExistingCartItems.find(
					(item) => item.key == itemKey
				);

				if (cartItem) {
					var newProperties = cartItem.properties;
					if (itemType == "film") {
						newProperties = {
							...newProperties,
							data: {
								...newProperties.data,
								value: {
									...newProperties.data.value,

									title:
										document.querySelector(
											`#MemoriesModal-${blockId} input[name="memories-title"][data-index="1"]`
										)?.value ?? "",
									media_date:
										document.querySelector(
											`#MemoriesModal-${blockId} input[name="memories-date"][data-index="1"]`
										)?.value ?? null,
								},
							},
						};
					} else {
						newProperties = {
							...newProperties,
							data: {
								...newProperties.data,
								value: {
									...newProperties.data.value,
									customizations:
										newProperties.data.value.customizations.map(
											(customization, index) => {
												var titleInput =
													document.querySelector(
														`#MemoriesModal-${blockId} input[name="memories-title"][data-index="${
															index + 1
														}"]`
													);
												var dateInput =
													document.querySelector(
														`#MemoriesModal-${blockId} input[name="memories-date"][data-index="${
															index + 1
														}"]`
													);

												var object = {
													...customization,
													title:
														titleInput?.value ?? "",
													media_date:
														dateInput?.value ??
														null,
												};

												if (itemType == "video") {
													var rewindValue =
														document.querySelector(
															`#MemoriesModal-${blockId} input[name="memories-rewind"][data-index="${
																index + 1
															}"]`
														);

													if (rewindValue.checked)
														object.rewind = true;
												}

												return object;
											}
										),
								},
							},
						};
					}

					event.target.closest("button").disabled = true;

					return this.cartTable
						.changeCart(
							JSON.stringify({
								id: String(itemKey),
								quantity: cartItem.quantity,
								properties: newProperties,
							})
						)
						.then(() => window.location.reload());
				}
			}
		});
	}
}

customElements.define(
	"capture-cart-memories-button",
	CaptureCartMemoriesButton
);

class CaptureCartTable extends HTMLElement {
	constructor() {
		super();
		this.captureCart = document.querySelector("capture-cart-items");

		this.clearCartButton = document.querySelector(
			"button.clear-cart-button"
		);
		this.clearCartButton.addEventListener("click", (e) => {
			this.captureCart.clearCart().then((w) => window.location.reload());
		});

		this.cartItemsJson =
			document.getElementById("CartItems-json")?.textContent ?? null;
		this.cartItems = JSON.parse(this.cartItemsJson);
		this.dvdId = this.getAttribute("data-dvd-product-id");
    this.upscaleId = this.getAttribute("data-upscale-product-id");
		this.usbId = this.getAttribute("data-usb-product-id");
		this.loading = document.querySelector(".full-screen-loading-overlay");
		this.initialize();
	}

	getData(eventTarget) {
		const thisClosest = eventTarget.closest("tr");
		const lineItemId = thisClosest.getAttribute("data-item-id");
		const lineItemKey = thisClosest.getAttribute("data-item-key");
		const lineItemIndex = thisClosest.getAttribute("data-item-index");
		const lineItemProperties = this.getLineItemProperties(lineItemIndex);
		const lineItemType = thisClosest.getAttribute("data-item-type");
		const lineItemQuantity = thisClosest.getAttribute("data-item-quantity");
    const hasPayload = thisClosest.getAttribute("data-has-payload");

		const lineItemAdditionalIds = [
			thisClosest.getAttribute("data-additional-item-id"),
			thisClosest.getAttribute("data-additional-item-slide-id"),
			thisClosest.getAttribute("data-additional-item-negative-id"),
		];
		const lineItemTimestamp = thisClosest.getAttribute(
			"data-item-timestamp"
		);
		const priceLineItem = thisClosest.querySelector(".money");
		const dvdLineItem = document.getElementById(
			`CartItem-dvd-${lineItemIndex}`
		);
    const upscaleLineItem = document.getElementById(
			`CartItem-upscale-${lineItemIndex}`
		);
		const upsell = thisClosest.getAttribute("data-item-upsell");
		const childDvdItems = this.cartItems.filter((item) => {
			return (
				item.id == this.dvdId &&
				item.properties?.timeStamp?.date == lineItemTimestamp
			);
		});
		const childUpscaleItems = this.cartItems.filter((item) => {
			return (
				item.id == this.upscaleId &&
				item.properties?.timeStamp?.date == lineItemTimestamp
			);
		});


		const childAdditionalItems = this.cartItems.filter((item) => {
			return (
				lineItemAdditionalIds.includes(String(item?.id)) &&
				(item.properties?.timeStamp?.date == lineItemTimestamp || hasPayload == 'false')
			);
		});
		const lineItemLoadingOverlay =
			thisClosest.querySelectorAll(".loading-overlay");
		const lineItemError = thisClosest.querySelector(".cart-item__error");
		const lineItemErrorText = lineItemError?.querySelector(
			".cart-item__error-text"
		);
		return {
			lineItemId,
			lineItemKey,
			lineItemIndex,
			lineItemProperties,
			lineItemType,
			priceLineItem,
			dvdLineItem,
			upsell,
			lineItemQuantity,
			lineItemTimestamp,
			childDvdItems,
			childAdditionalItems,
			lineItemAdditionalIds,
			lineItemLoadingOverlay,
			lineItemError,
			lineItemErrorText,
      upscaleLineItem,
      childUpscaleItems,
		};
	}

	getEstimatedTotal(lineItemKey) {
		var total = 0;
		var lineItems = document.querySelectorAll(
			`[data-item-key="${lineItemKey}"]`
		);
		lineItems.forEach((lineItem) => {
			var upsell = lineItem.getAttribute("data-item-upsell");
			var price = Number(lineItem.getAttribute("data-item-line-price"));
			if (upsell == "dvd") {
				var quantity = Number(
					lineItem.getAttribute("data-item-dvd-quantity")
				);
				if (quantity) total += price * quantity;
			} else {
				total += price;
			}
		});
		return total;
	}

	getFormData(lineItemId, lineItemKey) {
		var formData = [];
		formData.push({
			id: "id",
			value: lineItemId,
		});
		var formInputNames = [
			"album-quantity",
			"video-quantity",
			"default-quantity",
			"film-quantity",
			"digital-quantity",
			"photo-quantity",
			"extra-film",
			"extra-photo",
			"extra-album",
			"extra-slide",
			"extra-negative",
			"upsellDVDID",
			"dvd-quantity",
			"upsellUSBID",
			"usb-quantity",
      "upsellHDUpscaleID",
      "upscale-resolution",
			"theme-outputs",
			"music-outputs",
			"memories-title",
			"memories-date",
			"memories-rewind",
			"original-audio",
      "transfer_base_type",
		];
		formData.push({
			name: "estimatedTotal",
			value: this.getEstimatedTotal(lineItemKey),
		});


		formInputNames.forEach((inputName) =>
			formData.push(...document.getElementsByName(inputName))
		);
		return formData;
	}

	getLineItemProperties(lineItemIndex) {
		var lineItemProperties =
			document.getElementById(`Properties-${lineItemIndex}`)
				?.textContent ?? null;
		if (!lineItemProperties) return {};
		return this.parseJSON(lineItemProperties);
	}

	parseJSON(jsonDoc) {
		var object = {};
		if (!jsonDoc) return object;

		try {
			var json = JSON.parse(jsonDoc);
			for (var key in json) {
				object[json[key][0]] = json[key][1];
			}
			return object;
		} catch {
			return object;
		}
	}

	setQuantity(lineItemType, lineItemProperties, lineItemIndex) {

		switch (lineItemType) {
			case "album":
				this.setAlbumQuantity(lineItemProperties, lineItemIndex);
				break;
			case "digital-media":
				this.setDigitalQuantity(lineItemProperties, lineItemIndex);
				break;
			case "film":
				this.setFilmQuantity(lineItemProperties, lineItemIndex);
				break;
			case "photo":
				this.setPhotoQuantity(lineItemProperties, lineItemIndex);
				break;
			case "video":
				this.setVideoQuantity(lineItemProperties, lineItemIndex);
				break;
			default:
				this.setDefaultQuantity(lineItemProperties, lineItemIndex);
		}
	}

	setAlbumQuantity(lineItemProperties, lineItemIndex) {
		var albumQuantityAmounts =
			lineItemProperties.additional?.albumAmounts ?? [];
		if (!albumQuantityAmounts?.length) return;
		albumQuantityAmounts.forEach((value, index) => {
			var albumInput = document.querySelector(
				`input[name='album-quantity'][data-index='${
					index + 1
				}'][data-line-index='${lineItemIndex}']`
			);
			if (albumInput) {
        albumInput.value = value;
        if (value != '0') {
          var parentRow = $(`.album-lines[data-disp-index='${albumInput.getAttribute('data-index')}'][data-line-index='${lineItemIndex}']`);

          if (parentRow) {
            parentRow.show();
          }
        }

      }
		});
	}

	setDigitalQuantity(lineItemProperties, lineItemIndex) {
		var digitalQuantity = Number(lineItemProperties?.data?.value?.quantity);
		if (!digitalQuantity) return;
		var digitalInput = document.querySelector(
			`input[name='digital-quantity'][data-line-index='${lineItemIndex}']`
		);
		if (digitalInput) digitalInput.value = digitalQuantity;
	}

	setFilmQuantity(lineItemProperties, lineItemIndex) {
		var filmQuantityAmounts = lineItemProperties?.data?.value?.customizations;
		if (!filmQuantityAmounts?.length) return;
		filmQuantityAmounts.forEach((value) => {
			var filmInput = document.querySelector(
				`input[name='film-quantity'][data-sku='${value.sku}'][data-line-index='${lineItemIndex}']`
			);
			if (filmInput) {
        filmInput.value = value.quantity;
        if (value.quantity != '0') {
          var parentRow = $(`.film-reel-lines[data-disp-index='${filmInput.getAttribute('data-index')}'][data-line-index='${lineItemIndex}']`);

          if (parentRow) {
            parentRow.show();
          }
        }

      };
		});
	}

	setPhotoQuantity(lineItemProperties, lineItemIndex) {
		var photoQuantityAmounts =
			lineItemProperties.data?.value?.customizations ?? [];
		if (!photoQuantityAmounts?.length) return;
		photoQuantityAmounts.forEach((value) => {
			var photoInput = document.querySelector(
				`input[name='photo-quantity'][data-sku='${value.sku}'][data-line-index='${lineItemIndex}']`
			);
			if (photoInput) {
        photoInput.value = value.quantity;

        if (value.quantity != '0') {
          var parentRow = $(`.image-lines[data-disp-index='${photoInput.getAttribute('data-index')}'][data-line-index='${lineItemIndex}']`);

          if (parentRow) {
            parentRow.show();
          }
        }
      }
		});
	}

	setVideoQuantity(lineItemProperties, lineItemIndex) {
		var videoQuantity = Number(lineItemProperties?.data?.value?.quantity);
		if (!videoQuantity) return;
		var videoInput = document.querySelector(
			`input[name='video-quantity'][data-line-index='${lineItemIndex}']`
		);
		if (videoInput) videoInput.value = videoQuantity;
	}

	setDefaultQuantity(lineItemProperties, lineItemIndex) {
		var quantity = Number(lineItemProperties?.data?.value?.quantity);
		if (!quantity) return;
		var input = document.querySelector(
			`input[name='default-quantity'][data-line-index='${lineItemIndex}']`
		);
		if (input) input.value = quantity;
	}

	getUpdateCartItem(
		event,
		lineItemId,
		lineItemType,
		lineItemKey,
		lineItemTimestamp
	) {
		var formData = this.getFormData(lineItemId, lineItemKey);
		var lineIndex = Number(event.target.dataset.lineIndex) + 1; // 1-index based in Shopify
		// From capture-product.js
		var newCartItems = getCartItems(
			CONSTANTS.TEMPLATE_PRODUCT_MAP[lineItemType],
			lineItemKey,
			0,
			formData,
			lineItemTimestamp
		);
		return [newCartItems, lineIndex];
	}

	getInputName(lineItemType) {
		var inputName = "";
		switch (lineItemType) {
			case "album":
				inputName = "album";
				break;
			case "digital-media":
				inputName = "digital";
				break;
			case "film":
				inputName = "film";
				break;
			case "photo":
				inputName = "photo";
				break;
			case "video":
				inputName = "video";
				break;
		}
		return inputName;
	}

	async addUpscaleCartItemQuantity(
		upscaleQuantity,
		upscaleLineItem,
		inputName,
		lineItemQuantity,
		lineItemTimestamp
	) {
		var upscaleItemId = upscaleLineItem.getAttribute("data-item-upscale-id");
		var items = [];
		if (inputName == "video") {
			var totalProductQuantity = lineItemQuantity;
			for (var i = 0; i < totalProductQuantity; i++) {
				items.push({
					id: upscaleItemId,
					quantity: upscaleQuantity,
					properties: {
						timeStamp: {
							date: lineItemTimestamp,
						},
						for: inputName + " " + (i + 1),
					},
				});
			}
		}

		await this.captureCart.addToCart(JSON.stringify({ items }));
	}

	async addDVDCartItemQuantity(
		dvdQuantity,
		dvdLineItem,
		inputName,
		lineItemQuantity,
		lineItemTimestamp
	) {
		var dvdItemId = dvdLineItem.getAttribute("data-item-dvd-id");
		var items = [];
		if (
			inputName == "digital" ||
			inputName == "video" ||
			inputName == "album" ||
			inputName == "photo"
		) {
			var totalProductQuantity = lineItemQuantity;
			for (var i = 0; i < totalProductQuantity; i++) {
				items.push({
					id: dvdItemId,
					quantity: dvdQuantity,
					properties: {
						timeStamp: {
							date: lineItemTimestamp,
						},
						for: inputName + " " + (i + 1),
					},
				});
			}
		} else {
			items.push({
				id: dvdItemId,
				quantity: dvdQuantity,
				properties: {
					timeStamp: {
						date: lineItemTimestamp,
					},
					for: inputName,
				},
			});
		}

		await this.captureCart.addToCart(JSON.stringify({ items }));
	}

	async updateDVDCartItemQuantity(event, data) {
		var {
			lineItemKey,
			lineItemType,
			lineIndex,
			lineItemProperties,
			lineItemQuantity,
			dvdLineItem,
			childDvdItems,
			lineItemTimestamp,
		} = data;

		var inputName = this.getInputName(lineItemType);
		if (childDvdItems.length) {
			var updates = {};
			for (let i = 0; i < childDvdItems.length; i++) {
				updates[childDvdItems[i].key] = event.target.value;
			}
			await this.captureCart.updateCart(JSON.stringify({ updates }));
		} else {
			await this.addDVDCartItemQuantity(
				event.target.value,
				dvdLineItem,
				inputName,
				lineItemQuantity,
				lineItemTimestamp
			);
		}
    var newLineItemProperties = {};

    if (lineItemProperties?.data?.value ) {
  		var newLineItemProperties = {
  			...lineItemProperties,
  			data: {
  				...lineItemProperties.data,
  				value: {
  					...lineItemProperties.data.value,
  					dvd_copies: event.target.value,
  				},
  			},
  		};
    }
		var lineItemCart = { properties: newLineItemProperties };
		return this.captureCart.updateQuantity(
			lineIndex,
			lineItemQuantity,
			inputName,
			lineItemCart,
			lineItemKey
		);
	}

	async updateUpscaleCartItemQuantity(event, data) {
		var {
			lineItemKey,
			lineItemType,
			lineIndex,
			lineItemProperties,
			lineItemQuantity,
			upscaleLineItem,
			childUpscaleItems,
			lineItemTimestamp,
		} = data;

		var inputName = this.getInputName(lineItemType);
		if (childUpscaleItems.length) {
			var updates = {};
			for (let i = 0; i < childUpscaleItems.length; i++) {
				updates[childUpscaleItems[i].key] = event.target.value;
			}
			await this.captureCart.updateCart(JSON.stringify({ updates }));
		}
    // only remove not adding more than 1

    var newLineItemProperties = {};

    // blank or remove from parent line item payload
    if (lineItemProperties?.data?.value ) {
  		var newLineItemProperties = {
  			...lineItemProperties,
  			data: {
  				...lineItemProperties.data,
  				value: {
  					...lineItemProperties.data.value,
  					upscale: "",
  				},
  			},
  		};
    }
		var lineItemCart = { properties: newLineItemProperties };
		return this.captureCart.updateQuantity(
			lineIndex,
			lineItemQuantity,
			inputName,
			lineItemCart,
			lineItemKey
		);
	}

	updateUSBCartItemQuantity(event, data) {
		var { lineItemId, lineIndex, lineItemType, lineItemKey } = data;
		var inputName = this.getInputName(lineItemType);
		var lineItemCart = {
			id: lineItemId,
			quantity: event.target.value,
		};
		if (!lineItemKey) {
			var body = JSON.stringify({
				items: [lineItemCart],
			});
			return this.captureCart
				.addToCart(body)
				.then(() => window.location.reload());
		} else {
			return this.captureCart.updateQuantity(
				lineIndex,
				event.target.value,
				inputName,
				lineItemCart,
				lineItemKey
			);
		}
	}

  updateEnhancedContentCartItemQuantity(event, data) {
    var { lineItemId, lineIndex, lineItemType, lineItemKey } = data;
    var inputName = this.getInputName(lineItemType);
    var lineItemCart = {
      id: lineItemId,
      quantity: event.target.value,
    };
    if (!lineItemKey) {
      var body = JSON.stringify({
        items: [lineItemCart],
      });
      return this.captureCart
        .addToCart(body)
        .then(() => window.location.reload());
    } else {
      return this.captureCart.updateQuantity(
        lineIndex,
        event.target.value,
        inputName,
        lineItemCart,
        lineItemKey
      );
    }
  }

  updateSubscriptionCartItemQuantity(event, data) {

    var { lineItemId, lineIndex, lineItemType, lineItemKey} = data;
    var inputName = this.getInputName(lineItemType);
    var lineItemCart = {
      id: lineItemId,
      quantity: event.target.value
    };

    // add new
    if (!lineItemKey) {
      // for example
      // https://{your-recurpay-subdomain}.recurpay.com/storefront/api/{api_version}/variants/{variant_id}/plans

      const itemRaw = document.getElementById('item-raw');
      const jsonString = itemRaw.textContent;
      const itemData = JSON.parse(jsonString);

      var selling_plan_id = itemData?.selling_plan_allocations[0]?.selling_plan_id;
      if (selling_plan_id) {
        lineItemCart["selling_plan"] = selling_plan_id;
      }

      // add to cart
      var body = JSON.stringify({
        items: [
          lineItemCart
        ]

      });

      return this.captureCart
        .addToCart(body)
        .then(() => window.location.reload());

    } else {
      // remove or update old quantity
      return this.captureCart.updateQuantity(
        lineIndex,
        event.target.value,
        inputName,
        lineItemCart,
        lineItemKey
      );
    }
  }

	// Doesn't have additional product items
	async updateNonAdditionalCartItemQuantity(event, data) {
		var {
			lineItemId,
			lineIndex,
			lineItemType,
			lineItemKey,
			childDvdItems,
      childUpscaleItems,
			lineItemTimestamp,
			dvdLineItem,
      upscaleLineItem,
		} = data;


		var newQuantity = event.target.value;
		var inputName = this.getInputName(lineItemType);
		if (Number(newQuantity) > CONSTANTS.VIDEO.THRESHOLD) {
			newQuantity = CONSTANTS.VIDEO.THRESHOLD;
		}

		var [newCartItems, lineIndex] = this.getUpdateCartItem(
			event,
			lineItemId,
			lineItemType,
			lineItemKey,
			lineItemTimestamp
		);

		if (childDvdItems.length) {
			var updates = {};
			for (let i = 0; i < childDvdItems.length; i++) {
				updates[childDvdItems[i].key] = 0;
			}
			await this.captureCart.updateCart(JSON.stringify({ updates }));
			await this.addDVDCartItemQuantity(
				childDvdItems[0].quantity,
				dvdLineItem,
				inputName,
				event.target.value,
				lineItemTimestamp
			);
		}

    if (childUpscaleItems.length) {
			var updates = {};
			for (let i = 0; i < childUpscaleItems.length; i++) {
				updates[childUpscaleItems[i].key] = 0;
			}
      // directly remove all child upscale items
			await this.captureCart.updateCart(JSON.stringify({ updates }));
      // add them back with new quantity
			await this.addUpscaleCartItemQuantity(
				childUpscaleItems[0].quantity,
				upscaleLineItem,
				inputName,
				event.target.value,
				lineItemTimestamp
			);

    }

    // update this item's quantity
		var lineItemCart = newCartItems.find((item) => item?.id == lineItemKey);
		return this.captureCart.updateQuantity(
			lineIndex,
			newQuantity,
			inputName,
			lineItemCart,
			lineItemKey
		);
	}

	async updateAdditionalCartItemQuantity(event, data, isRemove) {
		var {
			lineItemId,
			lineIndex,
			lineItemType,
			lineItemKey,
			childDvdItems,
			childAdditionalItems,
			lineItemTimestamp,
			lineItemAdditionalIds,
			dvdLineItem,
		} = data;
		var inputName = this.getInputName(lineItemType);
		var [newCartItems, lineIndex] = this.getUpdateCartItem(
			event,
			lineItemId,
			lineItemType,
			lineItemKey,
			lineItemTimestamp
		);
		var updates = {};
		// Handle additional product types
		var additionalItems = newCartItems.filter((item) =>
			lineItemAdditionalIds.includes(String(item?.id))
		);
		// Remove all additional elements first
		if (childAdditionalItems.length) {
			for (let i = 0; i < childAdditionalItems.length; i++) {
				updates[childAdditionalItems[i].key] = 0;
			}
		}

		var lineItemCart = newCartItems.find((item) => item?.id == lineItemKey);

		if (childDvdItems.length) {
			for (let i = 0; i < childDvdItems.length; i++) {
				updates[childDvdItems[i].key] = 0;
			}
		}

		if (Object.keys(updates).length)
			await this.captureCart.updateCart(JSON.stringify({ updates }));

		if (childDvdItems.length && !isRemove) {
			await this.addDVDCartItemQuantity(
				childDvdItems[0].quantity,
				dvdLineItem,
				inputName,
				lineItemCart.quantity,
				lineItemTimestamp
			);
		}

		if (additionalItems.length && !isRemove) {
			// Add all additional elements first
			await this.captureCart.addToCart(
				JSON.stringify({
					items: additionalItems,
				})
			);
		}

		if (isRemove) {
      lineItemCart.quantity = 0;
    }
		return this.captureCart.updateQuantity(
			lineIndex,
			lineItemCart.quantity,
			inputName,
			lineItemCart,
			lineItemKey
		);
	}

	updateCartItemQuantity(event, isRemove) {

		var data = this.getData(event.target);
		var inputName = this.getInputName(data.lineItemType);

		// enable loading
		this.enableLoading(data.lineItemLoadingOverlay);

		if (data.upsell == "dvd") {
			return this.updateDVDCartItemQuantity(event, data);
		} else if (data.upsell == "usb") {
			return this.updateUSBCartItemQuantity(event, data);
    } else if (data.upsell == "enhanced-content") {
      return this.updateEnhancedContentCartItemQuantity(event, data);
    } else if (data.upsell == "subscription") {
      return this.updateSubscriptionCartItemQuantity(event, data);
    } else if (data.upsell == "upscale") {
      return this.updateUpscaleCartItemQuantity(event, data);
		} else {
			if (inputName == "digital" || inputName == "video") {
				return this.updateNonAdditionalCartItemQuantity(event, data);
			}
			return this.updateAdditionalCartItemQuantity(event, data, isRemove);
		}
	}

	enableLoading(lineItemLoadingOverlay) {
		const mainCartItems = document.getElementById("main-cart-items");
		mainCartItems.classList.add("cart__items--disabled");

		if (lineItemLoadingOverlay.length) {
			lineItemLoadingOverlay.forEach((overlay) =>
				overlay.classList.remove("hidden")
			);
		}

		document.activeElement.blur();
	}

	initialize() {
		const inputs = document.querySelectorAll(`input[name*='quantity']`);
		const debouncedOnChange = debounce((event) => {
			this.updateCartItemQuantity(event);
		}, 300);

		inputs.forEach((input) => {
			// Set quantity
			var {
				lineItemProperties,
				lineItemType,
				lineItemIndex,
				upsell,
				lineItemErrorText,
			} = this.getData(input);


			input.addEventListener("change", (event) => {
				// Make sure to not go over the threshold
				if (
					(lineItemType == "album" || lineItemType == "photo") &&
					!upsell
				) {
					if (
						Number(event.target.value) > CONSTANTS.ALBUM.MAX_INPUT
					) {
						input.value = CONSTANTS.ALBUM.MAX_INPUT;
						lineItemErrorText.innerHTML = `Maximum quantity for input is ${CONSTANTS.ALBUM.MAX_INPUT}`;
						return;
					} else {
						lineItemErrorText.innerHTML = "";
					}
				}

				if (lineItemType == "film" && !upsell) {
					if (Number(event.target.value) > CONSTANTS.FILM.MAX_INPUT) {
						input.value = CONSTANTS.FILM.MAX_INPUT;
						lineItemErrorText.innerHTML = `Maximum quantity for input is ${CONSTANTS.FILM.MAX_INPUT}`;
						return;
					} else {
						lineItemErrorText.innerHTML = "";
					}
				}

				if (
					(lineItemType == "video" ||
						lineItemType == "digital-media" ||
						lineItemType == "digital") &&
					!upsell
				) {
					if (
						Number(event.target.value) > CONSTANTS.VIDEO.THRESHOLD
					) {
						input.value = CONSTANTS.VIDEO.THRESHOLD;
						lineItemErrorText.innerHTML = `Maximum quantity for input is ${CONSTANTS.VIDEO.THRESHOLD}`;
						return;
					} else {
						lineItemErrorText.innerHTML = "";
					}
				}
				if (upsell == "usb" || upsell == "dvd") {
					if (Number(event.target.value) > CONSTANTS.USB.MAX_INPUT) {
						input.value = CONSTANTS.USB.MAX_INPUT;
						lineItemErrorText.innerHTML = `Maximum quantity for ${upsell} input is ${CONSTANTS.USB.MAX_INPUT}`;
						return;
					} else {
						lineItemErrorText.innerHTML = "";
					}
				}

				debouncedOnChange(event);
			});

			this.setQuantity(lineItemType, lineItemProperties, lineItemIndex);
		});
	}
}

customElements.define("capture-cart-table", CaptureCartTable);

class CaptureCartItems extends HTMLElement {
	constructor() {
		super();

		this.lineItemStatusElement =
			document.getElementById("shopping-cart-line-item-status") ||
			document.getElementById("CartDrawer-LineItemStatus");

		this.currentItemCount = Array.from(
			this.querySelectorAll('[name="updates[]"]')
		).reduce(
			(total, quantityInput) => total + parseInt(quantityInput.value),
			0
		);
	}

	onChange(event) {
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute("name")
		);
	}

	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
			{
				id: "main-cart-footer",
				section: document.getElementById("main-cart-footer").dataset.id,
				selector: ".js-contents",
			},
		];
	}

	updateQuantity(line, quantity, name, other, key) {
		var bodyObject = {
			sections: this.getSectionsToRender().map(
				(section) => section.section
			),
			sections_url: window.location.pathname,
			...other,
		};
		if (Number(quantity) >= 0) bodyObject.quantity = Number(quantity);
		if (key) bodyObject.id = key;
		else bodyObject.line = line;
		const body = JSON.stringify(bodyObject);
		const condition = this.getAttribute("data-main-product-ids").split(",");

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);

				if (quantity == 0) {
					// clear cart if no main transfer item is left
          const mainItemCount = parsedState.items.filter((item) =>
						condition.includes(String(item.product_id))
					).length;
					if (mainItemCount == 0) {
						return this.clearCart().then(() =>
							window.location.reload()
						);
					}
          // clear ec item if there is no more videos
          let enhancedContentRow = $(".enhanced-content-item");
          if (enhancedContentRow.length > 0) {
            let ecLineItemKey = enhancedContentRow.attr("data-item-key");
            if (key != ecLineItemKey) {
              // not removing ec line item itself
              let inCartVideoProductIds = $('#cart-video-products').attr("data-video-product-ids");
              let videoProductIds = [];

              if (inCartVideoProductIds) {
                videoProductIds = inCartVideoProductIds.split(",");
                videoProductIds.shift(); // remove first emppty '' element
              }

              let remainingVideoItems = parsedState.items.filter((item) =>
                videoProductIds.includes(String(item.product_id))
              )

              if (remainingVideoItems.length == 0) {
                let updates = {};
                updates[ecLineItemKey] = 0;
                let body = JSON.stringify({updates});
                this.updateCart(body).then(() => {
                  window.location.reload()
                });
                return; // will reload once second update finishes
              }
            } // != ecLineItemKey
          } // still is ec row

          // if there is selling plan item
          // if no subscription item
          // updatecart to remove selling plan item

				} // quantity == 0
				return window.location.reload();
			})
			.catch((e) => {
				this.querySelectorAll(".loading-overlay").forEach((overlay) =>
					overlay.classList.add("hidden")
				);
				const errors =
					document.getElementById("cart-errors") ||
					document.getElementById("CartDrawer-CartErrors");
				errors.textContent = window.cartStrings.error;
				this.disableLoading();
			});
	}

	updateLiveRegions(line, itemCount) {
		if (this.currentItemCount === itemCount) {
			const lineItemError =
				document.getElementById(`Line-item-error-${line}`) ||
				document.getElementById(`CartDrawer-LineItemError-${line}`);
			const quantityElement =
				document.getElementById(`Quantity-${line}`) ||
				document.getElementById(`Drawer-quantity-${line}`);
			if (lineItemError)
				lineItemError.querySelector(
					".cart-item__error-text"
				).innerHTML = window.cartStrings.quantityError.replace(
					"[quantity]",
					quantityElement.value
				);
		}

		this.currentItemCount = itemCount;
		this.lineItemStatusElement.setAttribute("aria-hidden", true);

		const cartStatus =
			document.getElementById("cart-live-region-text") ||
			document.getElementById("CartDrawer-LiveRegionText");
		cartStatus.setAttribute("aria-hidden", false);

		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.add("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
			overlay.classList.remove("hidden")
		);

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading() {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.remove("cart__items--disabled");
	}

	clearCart() {
		return fetch(`cart/clear`);
	}
  // update 1 line item
	changeCart(body) {
		return fetch(`${routes.cart_change_url}`, {
			...fetchConfig(),
			...{ body },
		});
	}
  // add to cart multiple items
	addToCart(body) {
		return fetch(`${routes.cart_add_url}`, {
			...fetchConfig(),
			...{ body },
		}).catch((e) => console.log("ERROR", e));
	}

  //update multiple line items
	updateCart(body) {
		return fetch(`${routes.cart_update_url}`, {
			...fetchConfig(),
			...{ body },
		}).then((response) => {
			return response.json();
		}).catch((e) => console.log("ERROR", e));
	}



}

customElements.define("capture-cart-items", CaptureCartItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"change",
					debounce((event) => {
						const body = JSON.stringify({
							note: event.target.value,
						});
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, 300)
				);
			}
		}
	);
}
